import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-text">Страница не найдена</p>
        <Link to="/">
          <Button className="notfound-button">На главную</Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;

